import { createContext, useContext, useEffect, useState } from 'react';
import {
  getAuth,
  onAuthStateChanged,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signOut
} from 'firebase/auth';
import { db } from './../firebase';
import SplashScreen from '../components/common/splash-screen';
import { collection, doc, onSnapshot, query, where } from 'firebase/firestore';

const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {

  const auth = getAuth();

  const [user, setUser] = useState(null);
  const [businessUsers, setBusinessUsers] = useState(null);
  const [businessProfile, setBusinessProfile] = useState(null);
  const [settings, setSettings] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  async function getSettings(bid) {
    const unsubscribe = onSnapshot(query(collection(db, "Businesses", bid, "Settings")), (querySnapshot) => {
      const tempDoc = [];
      querySnapshot.forEach((doc) => {
        tempDoc.push({ id: doc.id, ...doc.data() });
      });

      setSettings(tempDoc);
    });

    return () => unsubscribe();
  }

  async function getBusinessData(bid) {
    const unsubscribe = onSnapshot(doc(db, "Businesses", bid), (doc) => {
      if (doc.exists) {
        setBusinessProfile({ id: doc.id, ...doc.data() });
        getSettings(bid);
      }
    });

    return () => unsubscribe();
  }

  async function getAllBusinessUsers(bid) {
    const unsubscribe = onSnapshot(query(collection(db, "Users"), where("businessID", "==", bid)), (querySnapshot) => {
      const tempDoc = [];
      querySnapshot.forEach((doc) => {
        tempDoc.push({ id: doc.id, ...doc.data() });
      });

      setBusinessUsers(tempDoc);
    });

    return () => unsubscribe();
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (data) => {
      if (data && data) {
        data.getIdTokenResult().then((tokenResult) => {
          if (tokenResult) {
            setUser({ ...data, claims: tokenResult.claims });
            if (tokenResult && tokenResult.claims && tokenResult.claims.bid) {
              getBusinessData(tokenResult.claims.bid);
              getAllBusinessUsers(tokenResult.claims.bid);
            }
          }
        });
      }
      setIsLoading(false);
    });

    return () => unsubscribe();
  }, [auth])

  const login = (email, password) => {
    return signInWithEmailAndPassword(auth, email, password);
  }

  const resetPassword = (email) => {
    return sendPasswordResetEmail(auth, email);
  }

  const logout = async () => {
    setUser(null);
    await signOut(auth);
  }

  const context = { user, businessUsers, businessProfile, settings, login, resetPassword, logout };

  return (
    <AuthContext.Provider value={context}>
      {
        isLoading ?
          <SplashScreen />
          :
          children
      }
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext);